
function TermsAndConditions() {
    return (
        <>
            <div className="border-2 border-[#d3c8bd80] p-6 max-w-4xl inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30 mx-auto text-[#333] bg-white rounded-xl mt-10">

                <div className="border-2  border-[#ecd8ca80] text-[#361A06] p-6 mt-4 lg:mt-0 rounded-xl bg-white shadow-xl w-full sm:max-w-lg md:max-w-4xl relative">

                    <p className='font-bold text-[24px] uppercase font-david text-[#FD8531]'>Shyama Yoga Studio</p>
                    <h1 className="text-4xl font-bold text-start text-[#361A06] mb-4">Terms & Conditions</h1>


                    <p className="font-medium text-[#361A06] text-lg mb-4">
                        By accessing this website and registering for any program, class, workshop, or service offered by Shyama Yoga Studio, you agree to the following Terms & Conditions, Cancellation & Refund Policy, and Shipping Policy.
                    </p>

                    {/* ----------------- 1. PROGRAM REGISTRATION ----------------- */}
                    <h2 className="font-bold text-xl text-[#361A06] mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        1. Program Registration
                    </h2>
                    <p className="text-lg">
                        All registrations for yoga programs (online or offline) conducted by Shyama Yoga Studio are confirmed only after successful payment.
                    </p>

                    {/* ----------------- 2. PAYMENTS ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        2. Payments
                    </h2>
                    <p className="text-lg mb-4">
                        All payments are processed securely through authorized third-party payment gateways.
                        Shyama Yoga Studio does not store or have access to your card, UPI, or bank details.
                    </p>

                    {/* ----------------- 3. REFUND & TRANSFER ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        3. Refund & Transfer
                    </h2>

                    <p className="text-lg mb-4">
                        All registrations are non-refundable and non-transferable once confirmed.
                        However, in the case of genuine and unavoidable circumstances, the registration fee may be carried forward to the next available program for up to three (3) months, subject to prior intimation and approval by Shyama Yoga Studio.

                        <p>Requests must be emailed To <strong>support@shyama-yoga.com</strong>
                        </p>                    </p>

                    {/* ----------------- 4. PROGRAM CHANGES ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        4. Program Changes
                    </h2>
                    <p className="text-lg mb-2">Shyama Yoga Studio reserves the right To:</p>
                    <ul className="list-disc ml-6 text-lg mb-4">
                        <li>Modify program schedules, batch timings, or instructors</li>
                        <li>Reschedule or cancel programs due to unforeseen circumstances</li>
                    </ul>

                    <p className="text-lg mb-4">
                        Participants will be informed in advance and suitable alternatives will be provided.
                    </p>

                    {/* ----------------- 5. HEALTH & RESPONSIBILITY ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        5. Health & Responsibility
                    </h2>
                    <p className="text-lg mb-2">
                        Participants are responsible for ensuring they are medically fit to participate in yoga practices.
                    </p>
                    <p className="text-lg mb-4">
                        Shyama Yoga Studio shall not be liable for any injury, discomfort, or health issue arising due To:                    </p>
                    <ul className="list-disc ml-6 text-lg mb-4">
                        <li>Non-disclosure of medical conditions</li>
                        <li>Incorrect practice outside guided sessions</li>
                    </ul>

                    {/* ----------------- 6. ONLINE SESSIONS ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        6. Online Sessions
                    </h2>
                    <p>For online programs:</p>
                    <ul className="list-disc ml-6 text-lg mb-4">
                        <li>Participants must ensure a stable internet connection</li>
                        <li>Missed sessions are not eligible for refunds</li>
                    </ul>

                    {/* ----------------- 7. INTELLECTUAL PROPERTY ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        7. Intellectual Property
                    </h2>
                    <p className="text-lg mb-4">
                        All content, recordings, materials, instructions, and teachings are the intellectual property of Shyama Yoga Studio and must not be recorded, reproduced, or distributed without written permission                    </p>

                    {/* ----------------- 8. CODE OF CONDUCT ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        8. Code of Conduct
                    </h2>
                    <p className="text-lg mb-4">
                        Participants are expected to maintain discipline, punctuality, and respectful behavior.
                        For online sessions, participants may be required to keep their cameras switched on for safe guidance.
                        Shyama Yoga Studio reserves the right to deny continuation to participants who fail to follow guidelines, without any refund.
                    </p>

                    {/* ----------------- 9. GOVERNING LAW ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        9. Governing Law
                    </h2>
                    <p className="text-lg mb-4">
                        These terms shall be governed and interpreted in accordance with the laws of India.                    </p>

                    {/* ----------------- 10. CONTACT INFO ----------------- */}
                    <h2 className="font-bold text-xl mt-6 mb-2 inline-block border-b border-[#9e7755]">
                        10. Contact Information
                    </h2>
                    <p>For any queries related to registrations or policies, please contact:</p>

                    <p className="text-lg mb-2">
                        📧 Email:<strong>support@shyama-yoga.com</strong>
                    </p>
                    <p className="text-lg mb-4">
                        📞 Phone: <strong>+91 8500409800</strong>
                    </p>

                    {/* ----------------- CANCELLATION & REFUND POLICY ----------------- */}
                    <h1 className="text-3xl font-bold mt-8 mb-2 text-[#361A06] inline-block border-b border-[#9e7755]">
                        Cancellation & Refund Policy
                    </h1>

                    <p className="text-lg mb-4">
                        All registrations for Hatha Yoga programs, workshops, and sessions (online or offline) are non-refundable and non-transferable once confirmed.                    </p>

                    <p className="text-lg mb-4">

                        If a participant is unable to attend due to genuine and unavoidable reasons, the registration fee may be carried forward to the next available program for up to three (3) months, subject to prior approval                    </p>

                    <p className="text-lg mb-4">
                        To request consideration, email <strong>support@shyama-yoga.com</strong> with your registration details.
                    </p>
                    <p className="text-lg mb-4">

                        All decisions regarding carry-forward requests are at the sole discretion of Shyama Yoga Studio.                    </p>

                    {/* ----------------- SHIPPING POLICY ----------------- */}
                    <h1 className="text-3xl font-bold mt-8 mb-2 text-[#361A06] inline-block border-b border-[#9e7755]">
                        Shipping Policy
                    </h1>

                    <p className="text-lg mb-4">
                        Shyama Yoga Studio offers online yoga sessions, workshops, and wellness programs.
                    </p>

                    <ul className="list-disc ml-6 text-lg mb-4">
                        <li>No physical products are shipped.</li>
                        <li> Access details for online sessions are shared via email or WhatsApp after successful payment.</li>
                    </ul>
                    <p>For offline programs, venue and timing details are communicated directly to registered participants.</p>
                    <p className="text-lg mt-6">If you have any questions, please contact <strong>support@shyama-yoga.com</strong></p>
                </div>
            </div>
        </>
    );
}

export default TermsAndConditions;
